import React, { useState } from 'react';
import { ResetPasswordModal } from './ResetPasswordModal'; // import the other modal

export function LoginModal() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    async function Login() {
        setLoading(true);

        let country;
        try {
            const countryResponse = await fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry');
            country = await countryResponse.text();
        } catch (err) {
            console.error('Failed to fetch country:', err);
            setLoading(false);
            return;
        }

        const response = await fetch(`https://apiv2.mobileartsme.com/login?serviceid=3566&phonenumber=${username}&password=${password}&type=signin&country=${country}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const result = await response.json();

        if (result.Error === 0) {
            if (result.Result.Status === 0) {
                setErrorMessage('');
                result.Result.phone = username;
                localStorage.setItem('PK_user', JSON.stringify(result.Result));

                const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
                modal.hide();
                window.location.reload();
            } else {
                setErrorMessage(result.Result.Description);
            }
        } else {
            setErrorMessage(result.Result);
        }

        setLoading(false);
    }

    return (
        <>
            <div className="modal fade" id="loginModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="d-flex flex-column mb-3" style={{ border: 'none' }}>
                            <div className="d-flex flex-row align-items-center justify-content-between">
                                <h1 className="modal-title mb-2" style={{ color: 'var(--main-yellow)', fontWeight: '800' }}>
                                    Login
                                </h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <p>
                                Login to enjoy our wide collections of <br /> videos with 30+ categories
                            </p>
                        </div>

                        <div className="d-flex flex-column gap-3 mb-4">
                            <div>
                                <h6 className="bold">Username</h6>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your username"
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>

                            <div>
                                <h6 className="bold">Password</h6>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter your password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>

                            <button className="btn btn-primary" onClick={Login}>
                                {loading ? (
                                    <div className="spinner-border text-light" role="status">
                                        <span className="sr-only"></span>
                                    </div>
                                ) : (
                                    'Login'
                                )}
                            </button>

                            <div>
                                <p className="mb-2">
                                    <a
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#resetPasswordModal"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        Forgot Password?
                                    </a>
                                </p>
                                <p className="text-danger">{errorMessage}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ResetPasswordModal />
        </>
    );
}
